<template>
  <tile class="opc-basic-plus">
    <foldable v-model="isExpanded" :arrow="hasSelectedPlan" :edit="hasSelectedPlan" :title="title">
      <div slot="head">
        <div class="flex-container header-container">
          <img class="opc-basic-plus__logo right-cel" :src="IconZM" alt="Zoom One" />
          <div class="left-cel">
            <h1 class="opc-basic-plus__name">
              {{ title }}
              <i class="zm-icon-success main-icon" aria-hidden="true"></i>
            </h1>
            <div class="flex-container">
              <span class="opc-basic-plus__info" v-if="selectedPlan">{{ $t('billing.zone_basic_plus.bill_info', { number: 1, price: $money(selectedPlan.amount), billingCycle: $t('billing.common.per_billing_cycle.monthly')}) }}</span>
              <zm-button data-testid="checkout-button-96" v-if="isExpanded" class="opc-basic-plus__link" type="link" @click="handleOpenPlanDetails">
                {{ $t('billing.plan_details') }}
              </zm-button>
            </div>
          </div>
        </div>
      </div>
      <div class="opc-basic-plus__body flex-container">
        <div class="opc-basic-plus__body-item">
          <img class="opc-basic-plus__body-item-icon" :src="IconStopwatch" alt="">
          <div>
            <p class="opc-basic-plus__body-item-title">{{ $t('billing.zone_basic_plus.comments.extend_your_meetings') }}</p>
            <p class="opc-basic-plus__body-item-text">{{ $t('billing.zone_basic_plus.comments.extend_your_meetings_desc', [ZOBASICP_MEETING_MINUTES]) }}</p>
          </div>
        </div>
        <div class="opc-basic-plus__body-item">
          <img class="opc-basic-plus__body-item-icon" :src="IconCheckmark" alt="">
          <div>
            <p class="opc-basic-plus__body-item-title">{{ $t('billing.zone_basic_plus.comments.more_great_feature') }}</p>
            <p class="opc-basic-plus__body-item-text">{{ $t('billing.zone_basic_plus.comments.more_great_feature_desc', [ZOBASICP_CMR_STORAGE]) }}</p>
          </div>
        </div>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import plansMixin from '@/plans/mx/plan';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import IconZM from '@/assets/plans/icon_ZM.svg';
import IconCheckmark from '@/assets/plans/Checkmark.svg';
import IconStopwatch from '@/assets/plans/Stopwatch.svg';
import { mapGetters } from 'vuex';
import FullComparisonDialog from './dialog/full-comparison-dialog.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { pageConfig } from '@/common/service/page-config';

const ZOBASICP_MEETING_MINUTES = pageConfig.zobasicp_meeting_minutes || 80;
const ZOBASICP_CMR_STORAGE = pageConfig.zobasicp_cmr_storage || 1;

export default {
  components: {
    Foldable,
    Tile,
  },
  mixins: [plansMixin],
  data() {
    return {
      isExpanded: true,
      title: this.$t('billing.zone_basic_plus.title'),
      hasSelectedPlan: false,
      IconZM,
      IconStopwatch,
      IconCheckmark,
      fullComparisonDialog: new ServiceConfirm(FullComparisonDialog),
      form: {
        license: 1,
        billing_cycle: BILLING_CYCLE.MONTHLY,
      },
      ZOBASICP_MEETING_MINUTES,
      ZOBASICP_CMR_STORAGE,
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPlan() {
      return this.getSelectedPlans.find(item => item.type === planTypes.ZONE_BASIC_PLUS);
    },
  },
  methods: {
    handleOpenPlanDetails() {
      this.fullComparisonDialog.confirm();
    },
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-basic-plus {
  &.opc-tile {
    padding: 0;
    border-radius: 16px;
    overflow: hidden;
  }
  .flex-container {
    display: flex;
    align-items: center;
  }
  .header-container {
    padding: 24px;
  }
  .main-icon {
    color: $theme-color;
  }
  &__name {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: #00031F;
    @include media(mobile,tablet){
     width: 200px;
    }
  }
  &__logo {
    width: 44px;
    height: 44px;
    margin-right: 16px;
  }
  &__link {
    padding: 0;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #0B5CFF;
  }
  &__info {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #00031F;
    margin-right: 13px;
  }
  &__body {
    background: #F7F7F8;
    &-item {
      display: flex;
      padding: 37px 23px 48px 33px;
      justify-content: center;
      &-icon {
        margin-top: 5px;
        width: 25px;
        height: 25px;
        margin-right: 6px;
      }
      &-title {
        font-family: Almaden Sans;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #00053D;
      }
      &-text {
        font-family: Almaden Sans;
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: 0.01em;
        text-align: left;
        color: #515079;
      }
    }
  }
}
</style>
